import "../styles.css";
import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  clearData,
  createInitialOrder,
  setData,
  changeFormField,
  // getJumioVerificationFulfillmentUrl
  // getSignPassLinkUrl
} from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectOrderParams,
  makeSelectPayMonthlyItems,
  makeSelectPayTodayItems,
  makeSelectDeliveryDetailsItems,
  makeSelectReferralCode,
  makeSelectPaymentRequest,
  makeSelectOrderSummaryForm,
  makeSelectOrderSummaryFormInitialValues,
  makeSelectOrderSummaryPayload,
  makeSelectESigned,
  makeSelectPaymentModes,
  makeSelectFormattedSelectedNumber,
  makeSelectAddons,
  makeSelectPlanDetails,
  makeSelectDefaultPromoCodeOffers,
  makeSelectSessionToken,
  makeSelectIosDevice,
  makeSelectJumioRedirectUrl,
  makeSelectSadOrderParams,
  makeSelectOrder,
  makeSelectSimCount,
  makeSelectJumioData,
  makeSelectJumioSessionToken,
  makeSelectValidateIccId,
  makeSelectEKYCMessageData,
  makeSelectMyInfo,
  makeSelectMyInfoIsUsed,
  makeSelectMyInfoDetails,
  makeSelectSignPass,
  makeSelectJumioIsUsed,
  makeSelectGuestOrder,
  makeSelectIsWalletPromoCode,
  makeSelectEkycValidation,
  makeSelectMyInfoIsInvalid,
  makeSelectAppSettings
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import forEach from "lodash/forEach";
import {
  buildStoredJumioAuthHeaders,
  gotoUrl,
  setMyInfoFieldToClear,
  urlParam,
} from "utils/helpers";
import {
  forms,
} from "utils/constants";
import { makeSelectAcraFileUploaded, makeSelectCompanyDetails, makeSelectIsDeclaredCompanyDetails, makeSelectSimCountNewAndTransfer } from "ducks/selectors/planService";
import { get } from "lodash";
import { getRequestId } from "utils/localStorage";
import { createEnterpriseWorkFlow } from "ducks/actions/index";

const CompanyDetailsHOC = Component =>
  function Comp(props) {
     const {
      simCounts,
      myInfoDetails,
      createEnterpriseWorkFlow: callCreateEnterpriseWorkFlow,
      myInfoIsUsed
    } = props;
    useEffect(() =>{
      if(simCounts?.totalSimCount === 0){
        gotoUrl("/enterprise/automated-onboarding?reset=true")
      }
      if(urlParam("reset")){
        gotoUrl("/enterprise/automated-onboarding?reset=true")
      }
      if(!myInfoIsUsed){
        gotoUrl("/enterprise/automated-onboarding?reset=true")
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

     useEffect(() => {
      if(myInfoIsUsed){
        const headersValue = buildStoredJumioAuthHeaders();
        const payload = {
          workflow: "singpass_success",
          request_id: getRequestId(),
          status: "success",
          metadata: {
            nric: get(myInfoDetails, "uinfin"),
            name: get(myInfoDetails, "name.value"),
            dob: get(myInfoDetails, "dob.value"),
            mobileno: get(myInfoDetails, "mobileno.nbr.value"),
            email: get(myInfoDetails, "email.value"),
            address: "",
          }
        };
        callCreateEnterpriseWorkFlow(headersValue, payload, () => {});
      }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[myInfoIsUsed])

    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  formValues: makeSelectOrderSummaryForm(),
  payload: makeSelectOrderSummaryPayload(),
  order: makeSelectOrder(),
  paymentRequest: makeSelectPaymentRequest(),
  orderParams: makeSelectOrderParams(),
  sadOrderParams: makeSelectSadOrderParams(),
  isCreatingOrder: makeSelectIsFetchingData("order"),
  isIosDevice: makeSelectIosDevice(),
  nextPage: makeSelectJumioRedirectUrl(),
  isFetchingPaymentRequest: makeSelectIsFetchingData("paymentRequest"),
  payMonthlyItems: makeSelectPayMonthlyItems(),
  payTodayItems: makeSelectPayTodayItems("OrderSummary"),
  deliveryDetailsItems: makeSelectDeliveryDetailsItems(),
  referralCode: makeSelectReferralCode(),
  eSigned: makeSelectESigned(),
  paymentModes: makeSelectPaymentModes(),
  initialValues: makeSelectOrderSummaryFormInitialValues(),
  selectedNumber: makeSelectFormattedSelectedNumber(),
  addons: makeSelectAddons(),
  planDetails: makeSelectPlanDetails(),
  token: makeSelectSessionToken(),
  sim_count: makeSelectSimCount(),
  defaultPromoCodeOffers: makeSelectDefaultPromoCodeOffers(),
  isFetchingJumio: makeSelectIsFetchingData("jumio"),
  isFetchingJumioSessionToken: makeSelectIsFetchingData("jumioSessionToken"),
  validateIccid: makeSelectValidateIccId(),
  messageData: makeSelectEKYCMessageData(),
  myInfo: makeSelectMyInfo(),
  myInfoIsUsed: makeSelectMyInfoIsUsed(),
  myInfoDetails: makeSelectMyInfoDetails(),
  signPass: makeSelectSignPass(),
  jumioIsUsed: makeSelectJumioIsUsed(),
  jumioData: makeSelectJumioData(),
  jumioSessionToken: makeSelectJumioSessionToken(),
  jumioRedirectUrl: makeSelectJumioRedirectUrl(),
  guestOrder: makeSelectGuestOrder(),
  isWalletPromoCode: makeSelectIsWalletPromoCode(),
  ekycValidation: makeSelectEkycValidation(),
  myInfoIsInvalid: makeSelectMyInfoIsInvalid(),
  appSettings: makeSelectAppSettings(),
  isAcraFileUpload:makeSelectAcraFileUploaded(),
  simCounts:makeSelectSimCountNewAndTransfer(),
  companyDetails:makeSelectCompanyDetails(),
  isDeclaredCompanyDetails: makeSelectIsDeclaredCompanyDetails()
});

export function mapDispatchToProps(dispatch) {
  return {
    createEnterpriseWorkFlow: (headersValue, params) => {
      dispatch(createEnterpriseWorkFlow(headersValue, params));
    },
    createInitialOrder: (orderParams, callback) => {
      dispatch(createInitialOrder(orderParams, callback));
    },
    setIsAcraUpload: isAcraUpload => {
       dispatch(
        setData({
          key: "isAcraFileUpload",
          data: { isAcraUpload }
        })
      );
    },
    setMyInfoIsUsed: isUsed => {
      dispatch(
        setData({
          key: "myInfo",
          data: { isUsed }
        })
      );
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: "myInfoIsUsed",
          value: isUsed
        })
      );
    },
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: field,
          value: value
        })
      );
    },
    clearAllMyInfoData: () => {
      dispatch(clearData("myInfoDetails"));
      dispatch(clearData("myInfo"));
    },
    resetReferralCode: () =>
      dispatch(clearData(["referralCode", "selectedAddons"]))
  };
}

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    clearMyInfoUrlParam: () => {
      gotoUrl(window.location.pathname, true, {
        code: null,
        state: null
      });
    },
    clearMyInfoFormFields: (fieldNameToClear = []) => {
      const changeField = dispatchProps.changeField;
      const fieldMap = setMyInfoFieldToClear(fieldNameToClear);
      forEach(fieldMap, fieldName => {
        changeField(fieldName, null);
      });
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(withConnect, memo)(CompanyDetailsHOC(SmartRender));
